import React, { useState, useRef, useEffect } from 'react';
import { FiChevronDown, FiFolder } from 'react-icons/fi';

const FolderDropdown = ({ value, onChange, options = [], placeholder = 'Select or type new folder...' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div ref={wrapperRef} className="relative">
            <div className="relative">
                <input
                    type="text"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onFocus={() => setIsOpen(true)}
                    placeholder={placeholder}
                    className="form-input pr-10"
                    autoComplete="off"
                />
                <button
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-gray-500 hover:text-blue-600 transition"
                    tabIndex={-1}
                >
                    <FiChevronDown className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
                </button>
            </div>

            {isOpen && options.length > 0 && (
                <div className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                    {options.map((opt) => (
                        <button
                            key={opt}
                            type="button"
                            onClick={() => {
                                onChange(opt);
                                setIsOpen(false);
                            }}
                            className={`w-full text-left px-3 py-2 text-sm hover:bg-blue-50 flex items-center gap-2 transition ${value === opt ? 'bg-blue-50 text-blue-700 font-semibold' : 'text-gray-700'
                                }`}
                        >
                            <FiFolder className="text-gray-400 shrink-0" />
                            <span className="truncate">{opt}</span>
                        </button>
                    ))}
                </div>
            )}

            {isOpen && options.length === 0 && (
                <div className="absolute z-20 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg p-3 text-xs text-gray-500 italic">
                    No existing folders yet. Type a name to create one.
                </div>
            )}
        </div>
    );
};

export default FolderDropdown;